import { Award, Handshake, Leaf, MapPin } from "lucide-react";
import ownersImage from "@/assets/pietro,napoleone.jpg";

const AboutUs = () => {
  const values = [
    {
      icon: Award,
      title: "Esperienza trentennale",
      description: "Dal 1983 nel settore",
    },
    {
      icon: Handshake,
      title: "Consulenza personalizzata",
      description: "Sempre a tua disposizione",
    },
    {
      icon: Leaf,
      title: "Prodotti certificati",
      description: "Qualità garantita",
    },
    {
      icon: MapPin,
      title: "Punto di riferimento locale",
      description: "Nel cuore del Trasimeno",
    },
  ];

  return (
    <section id="chi-siamo" className="py-12 pb-6 bg-background">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="animate-fade-in-up">
            <img
              src={ownersImage}
              alt="Pietro e Napoleone Rubini - Proprietari Mangimi Rubini dal 1983"
              className="rounded-2xl shadow-[var(--shadow-large)] w-full h-auto"
              loading="lazy"
            />
          </div>

          {/* Content */}
          <div className="animate-fade-in-up" style={{ animationDelay: "0.2s" }}>
            <h2 className="mb-6 text-primary text-center md:text-left uppercase text-2xl md:text-4xl" style={{ fontFamily: 'Verdana, sans-serif' }}>La nostra storia</h2>
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed text-center md:text-left" style={{ fontFamily: 'Verdana, sans-serif' }}>
              Mangimi Rubini è un'azienda a conduzione familiare che dal 1983 si "prende cura" degli animali domestici e da allevamento della zona del Trasimeno, fornendo ai propri clienti mangimi e alimenti di prima qualità. Da allora il catalogo si è ampliato, spaziando dal pellet per stufe e caminetti ai concimi e arrivando a fiori ed alberi da frutto. La qualità dei prodotti e del servizio, invece, è rimasta eccezionale come sempre.
            </p>

            {/* Values Grid */}
            <div className="flex flex-col gap-4 md:grid md:grid-cols-2 md:gap-6 md:justify-items-start">
              {values.map((value, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 bg-card border border-border rounded-xl p-4 md:flex-col md:items-start md:text-left md:bg-transparent md:border-0 md:p-0"
                  style={{ animationDelay: `${0.3 + index * 0.1}s` }}
                >
                  <div className="w-12 h-12 flex-shrink-0 rounded-xl bg-primary/10 flex items-center justify-center">
                    <value.icon className="w-6 h-6 text-primary" />
                  </div>
                  <div className="flex-1 text-left">
                    <h4 className="font-heading font-semibold text-foreground mb-1 uppercase text-sm" style={{ fontFamily: 'Verdana, sans-serif' }}>
                      {value.title}
                    </h4>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
